import groupBy from 'lodash/groupBy';
import uniq from 'lodash/uniq';
import { Bar } from 'react-chartjs-2';

type Props = {
  data: Array<{
    access_date: string;
    scanner_name: string;
    count: number;
  }>;
};

type Dataset = Array<{
  label: string;
  data: number;
  backgroundColor: string;
}>;

export default function DashboardBZonePerDayWidget({ data }: Props) {
  const accessDates = uniq(data.map((item) => item.access_date));

  const colors = ['#004D40', '#00897B', '#4DB6AC', '#0D47A1', '#1E88E5', '#64B5F6', '#BF360C', '#F4511E', '#FF8A65'];

  const perScanner = groupBy(data, 'scanner_name');

  // filter out dev scanner names: "DEV1", "Alex", "Diemas"
  delete perScanner['DEV1'];
  delete perScanner['DEV2'];
  delete perScanner['Alex'];
  delete perScanner['Diemas'];

  const datasets = Object.keys(perScanner)
    .sort()
    .map((scannerName, index) => {
      return {
        label: scannerName,
        // data is an array of scannerName counts per date in accessDates
        data: accessDates.map((date) => perScanner[scannerName].find((item) => item.access_date === date)?.count || 0),
        backgroundColor: colors[index],
      };
    });

  const barChartData = {
    labels: accessDates,
    datasets,
  };

  return (
    <Bar
      data={barChartData}
      options={{
        responsive: true,
        scales: {
          // xAxes: [
          //   {
          //     stacked: true,
          //   },
          // ],
          yAxes: [
            {
              // stacked: true,
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      }}
    />
  );
}
